import React from "react";
import { Link } from "react-router-dom";

const CSS = `
  .pf-footer { position: relative; padding: 60px 0 0; overflow: hidden; border-top: 1px solid rgba(255,255,255,0.04); }
  .pf-footer-glow { position: absolute; top: 0; left: 50%; transform: translateX(-50%); width: 50%; height: 1px; background: linear-gradient(90deg, transparent, rgba(255,107,53,0.3), transparent); }
  .pf-footer-wrap { max-width: 1200px; margin: 0 auto; padding: 0 24px; position: relative; z-index: 1; }
  .pf-footer-grid { display: grid; grid-template-columns: 1.8fr 1fr 1fr 1.2fr; gap: 40px; padding-bottom: 40px; }
  .pf-footer-brand { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
  .pf-footer-logo { width: 34px; height: 34px; border-radius: 10px; background: linear-gradient(135deg, rgba(255,107,53,0.15), rgba(0,212,170,0.1)); border: 1px solid rgba(255,107,53,0.2); display: flex; align-items: center; justify-content: center; font-size: 1em; }
  .pf-footer-name { font-family: 'DM Serif Display', serif; font-size: 1em; color: #F0F0F5; }
  .pf-footer-name em { font-style: italic; background: linear-gradient(135deg, #FF6B35, #FFD23F); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .pf-footer-desc { font-size: 0.8em; color: rgba(240,240,245,0.25); line-height: 1.75; max-width: 260px; }
  .pf-footer-col-title { font-size: 0.68em; font-weight: 700; letter-spacing: 2.5px; text-transform: uppercase; color: rgba(255,107,53,0.4); margin-bottom: 18px; }
  .pf-footer-links { list-style: none; padding: 0; margin: 0; }
  .pf-footer-links li { margin-bottom: 10px; }
  .pf-footer-links a { font-size: 0.84em; font-weight: 500; color: rgba(240,240,245,0.3); text-decoration: none; display: inline-flex; align-items: center; gap: 6px; transition: all 0.25s ease; }
  .pf-footer-links a::before { content: '›'; color: #FF6B35; transition: transform 0.25s ease; }
  .pf-footer-links a:hover { color: #FF6B35; padding-left: 4px; }
  .pf-footer-cr { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 12px; font-size: 0.82em; color: rgba(240,240,245,0.3); line-height: 1.5; }
  .pf-footer-cr a { color: rgba(240,240,245,0.4); text-decoration: none; transition: color 0.25s ease; }
  .pf-footer-cr a:hover { color: #FF6B35; }
  .pf-footer-cr span:first-child { flex-shrink: 0; font-size: 1.1em; }
  .pf-footer-divider { height: 1px; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent); margin-bottom: 16px; }
  .pf-footer-bottom { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; padding-bottom: 16px; }
  .pf-footer-copy { font-size: 0.74em; color: rgba(240,240,245,0.18); }
  .pf-footer-copy strong { color: #FF6B35; font-weight: 700; }
  .pf-footer-dev { text-align: center; padding: 14px 0; font-size: 0.72em; color: rgba(240,240,245,0.14); border-top: 1px solid rgba(255,255,255,0.03); }
  .pf-footer-dev a { color: #FF6B35; text-decoration: none; font-weight: 600; }
  .pf-footer-dev a:hover { color: #FFD23F; }
  .pf-footer-accent { height: 2px; background: linear-gradient(90deg, #FF6B35 0%, #FFD23F 35%, #00D4AA 70%, #7C5CFC 100%); opacity: 0.3; }
  @media(max-width: 768px) { .pf-footer-grid { grid-template-columns: 1fr 1fr; gap: 28px; } }
  @media(max-width: 480px) { .pf-footer-grid { grid-template-columns: 1fr; } .pf-footer-bottom { justify-content: center; text-align: center; } }
`;

export default function Footer() {
  const yr = new Date().getFullYear();
  return (
    <>
      <style>{CSS}</style>
      <footer className="pf-footer">
        <div className="pf-footer-glow" />
        <div className="pf-footer-wrap">
          <div className="pf-footer-grid">
            <div>
              <div className="pf-footer-brand">
                <div className="pf-footer-logo">🧭</div>
                <div className="pf-footer-name">
                  Path<em>finder</em>
                </div>
              </div>
              <p className="pf-footer-desc">
                India's free career discovery platform for Class 10 students.
                Take our psychometric test and find your perfect career path.
              </p>
            </div>
            <div>
              <div className="pf-footer-col-title">Explore</div>
              <ul className="pf-footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/test">Discover Your Path</Link>
                </li>
                <li>
                  <Link to="/careers">Career Library</Link>
                </li>
                <li>
                  <Link to="/streams">Streams Guide</Link>
                </li>
                <li>
                  <Link to="/dashboard">Student Dashboard</Link>
                </li>
              </ul>
            </div>
            <div>
              <div className="pf-footer-col-title">Top Careers</div>
              <ul className="pf-footer-links">
                <li>
                  <Link to="/careers/graphic-designer">Graphic Designer</Link>
                </li>
                <li>
                  <Link to="/careers/ai-engineer">AI Engineer</Link>
                </li>
                <li>
                  <Link to="/careers/doctor">Doctor</Link>
                </li>
                <li>
                  <Link to="/careers/entrepreneur">Entrepreneur</Link>
                </li>
                <li>
                  <Link to="/careers/psychologist">Psychologist</Link>
                </li>
              </ul>
            </div>
            <div>
              <div className="pf-footer-col-title">Contact</div>
              <div className="pf-footer-cr">
                <span>✉️</span>
                <a href="mailto:siddhantgarg563@gmail.com">
                  siddhantgarg563@gmail.com
                </a>
              </div>
              <div className="pf-footer-cr">
                <span>📞</span>
                <a href="tel:+917898787604">7898787604</a>
              </div>
              <div className="pf-footer-cr">
                <span>🌐</span>
                <a
                  href="https://siddhantgarg.online"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  siddhantgarg.online
                </a>
              </div>
              <div className="pf-footer-cr" style={{ marginTop: 16 }}>
                <span>🎯</span>
                <span>
                  Built to help every Indian student find their perfect career
                </span>
              </div>
              <div className="pf-footer-cr">
                <span>🆓</span>
                <span>100% Free · No sign-up required</span>
              </div>
            </div>
          </div>
          <div className="pf-footer-divider" />
          <div className="pf-footer-bottom">
            <div className="pf-footer-copy">
              © {yr} <strong>Pathfinder</strong> · Made with ❤️ for Indian
              students
            </div>
          </div>
        </div>
        <div className="pf-footer-dev">
          Designed & Developed by{" "}
          <a
            href="https://siddhantgarg.online"
            target="_blank"
            rel="noopener noreferrer"
          >
            Siddhant Garg
          </a>
        </div>
        <div className="pf-footer-accent" />
      </footer>
    </>
  );
}
